// Supplier unavailable dates (docs/reference/SUPPLIER_UNAVAILABILITY.md). The supplier lists for
// quotes carry each supplier's upcoming_unavailability ranges ({start_date, end_date, reason},
// both ends inclusive); a supplier blocked on a build's dates isn't offered for that build.

const day = value => (value ? String(value).substring(0, 10) : null)

const addDays = (value, days) => {
    const d = new Date(`${day(value)}T00:00:00Z`)
    d.setUTCDate(d.getUTCDate() + days)
    return d.toISOString().substring(0, 10)
}

// The range blocking any day from start to last (inclusive), or null.
export function unavailableBetween(supplier, start, last = start) {
    const from = day(start)
    const to = day(last) || from
    if (!supplier || !from) return null
    return (supplier.upcoming_unavailability || []).find(r => day(r.start_date) <= to && day(r.end_date) >= from) || null
}

// Hotel nights: check-in up to the night before check-out.
export function unavailableForStay(supplier, check_in, check_out) {
    if (!check_in) return null
    const last = check_out && day(check_out) > day(check_in) ? addDays(check_out, -1) : check_in
    return unavailableBetween(supplier, check_in, last)
}

// The lead's whole stay (Quick Quote's accommodation): nights from the start date.
export function unavailableForLead(supplier, lead) {
    if (!lead || !lead.start_date) return null
    const nights = Math.max(parseInt(lead.duration, 10) || 1, 1)
    return unavailableBetween(supplier, lead.start_date, addDays(lead.start_date, nights - 1))
}

export function unavailableLabel(range) {
    if (!range) return ''
    const fmt = v => day(v).split('-').reverse().join('/')
    const dates = day(range.start_date) === day(range.end_date) ? fmt(range.start_date) : `${fmt(range.start_date)} – ${fmt(range.end_date)}`
    return `Unavailable ${dates}${range.reason ? ': ' + range.reason : ''}`
}
